import React, { createContext, useContext, useState, ReactNode } from "react";

interface BranchContextType {
  selectedBranch: string;
  setSelectedBranch: (branchId: string) => void;
}

const BranchContext = createContext<BranchContextType | undefined>(undefined);

interface BranchProviderProps {
  children: ReactNode;
}

export const BranchProvider: React.FC<BranchProviderProps> = ({ children }) => {
  const [selectedBranch, setSelectedBranch] = useState<string>("organization");

  const handleSetSelectedBranch = (branchId: string) => {
    // Ensure consistent handling of organization vs empty string
    if (branchId === "" || branchId === "organization") {
      setSelectedBranch("organization");
    } else {
      setSelectedBranch(branchId);
    }
  };

  return (
    <BranchContext.Provider
      value={{
        selectedBranch,
        setSelectedBranch: handleSetSelectedBranch,
      }}
    >
      {children}
    </BranchContext.Provider>
  );
};

export const useBranch = () => {
  const context = useContext(BranchContext);
  if (context === undefined) {
    throw new Error("useBranch must be used within a BranchProvider");
  }
  return context;
};
